export function getAuth0ErrorCode(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const code = (error as { error?: unknown }).error;
  return typeof code === 'string' ? code : undefined;
}

/** Auth0 SPA client cannot refresh or obtain tokens silently; user must sign in again. */
export function isAuth0SessionDead(error: unknown): boolean {
  const code = getAuth0ErrorCode(error);
  return code === 'login_required'
    || code === 'invalid_grant'
    || code === 'missing_refresh_token'
    || code === 'consent_required';
}
